/* eslint-disable no-template-curly-in-string */
/* Copyright (c) 2020-present CloudIO Inc */

import { Item } from 'componentregistry';

export const page: {
  set: Item<'ActionSet'>;
  card: Item<'Card'>;
  form: Item<'Form'>;
  menu: Item<'Menu'>;
  root: Item<'Page'>;
  avatar: Item<'Avatar'>;
  goBack: Item<'ActionGoBack'>;
  flexItem: Item<'FlexItem'>;
  menuItem: Item<'MenuItem'>;
  flexPanel: Item<'FlexPanel'>;
  menuItem1: Item<'MenuItem'>;
  backButton: Item<'Button'>;
  cardHeader: Item<'CardHeader'>;
  iconButton: Item<'IconButton'>;
  saveButton: Item<'Button'>;
  cardActions: Item<'CardActions'>;
  cardContent: Item<'CardContent'>;
  createRecord: Item<'ActionCreate'>;
  idNumberField: Item<'NumberField'>;
  saveDataStore: Item<'ActionSave'>;
  plusIconButton: Item<'IconButton'>;
  resetDataStore: Item<'ActionReset'>;
  triggerOnClick: Item<'TriggerOnClick'>;
  booleanCheckbox: Item<'Checkbox'>;
  menuItemDivider: Item<'MenuItemDivider'>;
  triggerOnClick1: Item<'TriggerOnClick'>;
  triggerOnClick2: Item<'TriggerOnClick'>;
  triggerOnClick3: Item<'TriggerOnClick'>;
  triggerOnClick4: Item<'TriggerOnClick'>;
  triggerOnClick5: Item<'TriggerOnClick'>;
  checkboxCheckbox: Item<'Checkbox'>;
  dateTimeDateField: Item<'DateField'>;
  numberNumberField: Item<'NumberField'>;
  createdByTextField: Item<'TextField'>;
  firstNameTextField: Item<'TextField'>;
  resetChangesMenuItem: Item<'MenuItem'>;
  creationDateDateField: Item<'DateField'>;
  lastUpdatedByTextField: Item<'TextField'>;
  lastUpdateDateDateField: Item<'DateField'>;
  sampleDataSourceAliasLocalDataStore: Item<'LocalDataStore'>;
  sampleDataSourceAliasDataStoreReference: Item<'DataStoreReference'>;
  saveDataStore1: Item<'ActionSave'>;
  set1: Item<'ActionSet'>;
  createRecord1: Item<'ActionCreate'>;
} = {
  avatar: {
    children: [],
    itemId: 'avatar',
    parent: 'cardHeader',
    props: {
      text: {
        type: 'expression',
        value: '$.sampleDataSourceAlias.firstName',
      },
    },
    type: 'Avatar',
  },
  backButton: {
    children: ['triggerOnClick5'],
    itemId: 'backButton',
    parent: 'cardActions',
    props: {
      startIcon: {
        iconName: '',
      },
      text: {
        type: 'text',
        value: 'Back',
      },
      variant: 'text',
    },
    type: 'Button',
  },
  booleanCheckbox: {
    children: [],
    itemId: 'booleanCheckbox',
    parent: 'form',
    props: {
      label: { type: 'text', value: 'Boolean' },
      viewAttribute: 'boolean',
    },
    type: 'Checkbox',
  },
  card: {
    children: ['cardHeader', 'cardContent', 'cardActions'],
    itemId: 'card',
    parent: 'sampleDataSourceAliasDataStoreReference',
    props: {},
    type: 'Card',
  },
  cardActions: {
    children: ['backButton', 'saveButton'],
    itemId: 'cardActions',
    parent: 'card',
    props: {},
    type: 'CardActions',
  },
  cardContent: {
    children: ['flexPanel'],
    itemId: 'cardContent',
    parent: 'card',
    props: {},
    type: 'CardContent',
  },
  cardHeader: {
    children: ['avatar', 'plusIconButton', 'iconButton'],
    itemId: 'cardHeader',
    parent: 'card',
    props: {
      title: {
        type: 'expression',
        value:
          "$.sampleDataSourceAlias.$isFromDB ? `Update ${$.sampleDataSourceAlias.firstName}` : 'Add New'",
      },
    },
    type: 'CardHeader',
  },
  checkboxCheckbox: {
    children: [],
    itemId: 'checkboxCheckbox',
    parent: 'form',
    props: {
      label: { type: 'text', value: 'Checkbox' },
      viewAttribute: 'checkbox',
    },
    type: 'Checkbox',
  },
  createRecord: {
    children: ['set'],
    itemId: 'createRecord',
    parent: 'triggerOnClick1',
    props: {
      alias: 'sampleDataSourceAlias',
    },
    type: 'ActionCreate',
  },
  createRecord1: {
    children: ['set1'],
    itemId: 'createRecord1',
    parent: 'triggerOnClick3',
    props: {
      alias: 'sampleDataSourceAlias',
    },
    type: 'ActionCreate',
  },
  createdByTextField: {
    children: [],
    itemId: 'createdByTextField',
    parent: 'form',
    props: {
      insertable: {
        type: 'boolean',
        value: false,
      },
      label: { type: 'text', value: 'Created By' },
      updatable: {
        type: 'boolean',
        value: false,
      },
      viewAttribute: 'createdBy',
    },
    type: 'TextField',
  },
  creationDateDateField: {
    children: [],
    itemId: 'creationDateDateField',
    parent: 'form',
    props: {
      insertable: {
        type: 'boolean',
        value: false,
      },
      label: { type: 'text', value: 'Creation Date' },
      showTime: true,
      updatable: {
        type: 'boolean',
        value: false,
      },
      viewAttribute: 'creationDate',
    },
    type: 'DateField',
  },
  dateTimeDateField: {
    children: [],
    itemId: 'dateTimeDateField',
    parent: 'form',
    props: {
      label: { type: 'text', value: 'Date Time' },
      showTime: true,
      viewAttribute: 'dateTime',
    },
    type: 'DateField',
  },
  firstNameTextField: {
    children: [],
    itemId: 'firstNameTextField',
    parent: 'form',
    props: {
      label: { type: 'text', value: 'First Name' },
      viewAttribute: 'firstName',
    },
    type: 'TextField',
  },
  flexItem: {
    children: ['form'],
    itemId: 'flexItem',
    parent: 'flexPanel',
    props: {},
    type: 'FlexItem',
  },
  flexPanel: {
    children: ['flexItem'],
    itemId: 'flexPanel',
    parent: 'cardContent',
    props: {},
    type: 'FlexPanel',
  },
  form: {
    children: [
      'idNumberField',
      'createdByTextField',
      'lastUpdatedByTextField',
      'creationDateDateField',
      'lastUpdateDateDateField',
      'firstNameTextField',
      'numberNumberField',
      'dateTimeDateField',
      'booleanCheckbox',
      'checkboxCheckbox',
    ],
    itemId: 'form',
    parent: 'flexItem',
    props: {},
    type: 'Form',
  },
  goBack: {
    children: [],
    itemId: 'goBack',
    parent: 'triggerOnClick5',
    props: {},
    type: 'ActionGoBack',
  },
  iconButton: {
    children: ['menu'],
    itemId: 'iconButton',
    parent: 'cardHeader',
    props: {
      toolTip: {
        type: 'text',
        value: 'More actions',
      },
    },
    type: 'IconButton',
  },
  idNumberField: {
    children: [],
    itemId: 'idNumberField',
    parent: 'form',
    props: {
      allowDecimal: false,
      label: { type: 'text', value: 'Id' },
      updatable: {
        type: 'boolean',
        value: false,
      },
      viewAttribute: 'id',
    },
    type: 'NumberField',
  },
  lastUpdateDateDateField: {
    children: [],
    itemId: 'lastUpdateDateDateField',
    parent: 'form',
    props: {
      insertable: {
        type: 'boolean',
        value: false,
      },
      label: { type: 'text', value: 'Last Update Date' },
      showTime: true,
      updatable: {
        type: 'boolean',
        value: false,
      },
      viewAttribute: 'lastUpdateDate',
    },
    type: 'DateField',
  },
  lastUpdatedByTextField: {
    children: [],
    itemId: 'lastUpdatedByTextField',
    parent: 'form',
    props: {
      insertable: {
        type: 'boolean',
        value: false,
      },
      label: { type: 'text', value: 'Last Updated By' },
      updatable: {
        type: 'boolean',
        value: false,
      },
      viewAttribute: 'lastUpdatedBy',
    },
    type: 'TextField',
  },
  menu: {
    children: [
      'menuItem',
      'resetChangesMenuItem',
      'menuItemDivider',
      'menuItem1',
    ],
    itemId: 'menu',
    parent: 'iconButton',
    props: {},
    type: 'Menu',
  },
  menuItem: {
    children: ['triggerOnClick3'],
    itemId: 'menuItem',
    parent: 'menu',
    props: {
      icon: {
        iconName: 'plus',
        iconType: 'light',
      },
      label: {
        type: 'text',
        value: 'Add New',
      },
    },
    type: 'MenuItem',
  },
  menuItem1: {
    children: ['triggerOnClick4'],
    itemId: 'menuItem1',
    parent: 'menu',
    props: {
      icon: {
        iconName: 'save',
        iconType: 'light',
      },
      label: {
        type: 'text',
        value: 'Save',
      },
    },
    type: 'MenuItem',
  },
  menuItemDivider: {
    children: [],
    itemId: 'menuItemDivider',
    parent: 'menu',
    props: {},
    type: 'MenuItemDivider',
  },
  numberNumberField: {
    children: [],
    itemId: 'numberNumberField',
    parent: 'form',
    props: {
      label: { type: 'text', value: 'Number' },
      viewAttribute: 'number',
    },
    type: 'NumberField',
  },
  plusIconButton: {
    children: ['triggerOnClick1'],
    itemId: 'plusIconButton',
    parent: 'cardHeader',
    props: {
      icon: {
        iconName: 'plus',
        iconType: 'light',
      },
      toolTip: {
        type: 'text',
        value: 'Add new row',
      },
    },
    type: 'IconButton',
  },
  resetChangesMenuItem: {
    children: ['triggerOnClick2'],
    itemId: 'resetChangesMenuItem',
    parent: 'menu',
    props: {
      icon: {
        iconName: 'undo',
        iconType: 'light',
      },
      label: {
        type: 'text',
        value: 'Reset Changes',
      },
    },
    type: 'MenuItem',
  },
  resetDataStore: {
    children: [],
    itemId: 'resetDataStore',
    parent: 'triggerOnClick2',
    props: {
      alias: 'sampleDataSourceAlias',
    },
    type: 'ActionReset',
  },
  root: {
    children: [
      'sampleDataSourceAliasLocalDataStore',
      'sampleDataSourceAliasDataStoreReference',
    ],
    itemId: 'root',
    parent: 'root',
    props: {
      windowTitle: {
        type: 'text',
        value: 'Blank Page',
      },
    },
    type: 'Page',
  },
  sampleDataSourceAliasDataStoreReference: {
    children: ['card'],
    itemId: 'sampleDataSourceAliasDataStoreReference',
    parent: 'root',
    props: {
      alias: 'sampleDataSourceAlias',
    },
    type: 'DataStoreReference',
  },
  sampleDataSourceAliasLocalDataStore: {
    children: [],
    itemId: 'sampleDataSourceAliasLocalDataStore',
    parent: 'root',
    props: {
      alias: 'sampleDataSourceAlias',
      dataFormat: 'ts',
      dataSource: 'sampleDataSource',
      tsData:
        '\nreturn [\n    {\n        firstName: "John",\n        number: 123.456,\n        dateTime: new Date().toISOString(),\n        boolean: true,\n        checkbox: "Y"\n    }\n];\n',
    },
    type: 'LocalDataStore',
  },
  saveButton: {
    children: ['triggerOnClick'],
    itemId: 'saveButton',
    parent: 'cardActions',
    props: {
      disableCondition: '!$.sampleDataSourceAlias.$dirty',
      startIcon: {
        iconName: 'save',
        iconType: 'light',
      },
      text: {
        type: 'text',
        value: 'Save',
      },
    },
    type: 'Button',
  },
  saveDataStore: {
    children: [],
    itemId: 'saveDataStore',
    parent: 'triggerOnClick',
    props: { alias: '' },
    type: 'ActionSave',
  },
  saveDataStore1: {
    children: [],
    itemId: 'saveDataStore1',
    parent: 'triggerOnClick4',
    props: { alias: '' },
    type: 'ActionSave',
  },
  set: {
    children: [],
    itemId: 'set',
    parent: 'createRecord',
    props: {
      attribute: 'dateTime',
      value: {
        type: 'expression',
        value: 'sysdate()',
      },
    },
    type: 'ActionSet',
  },
  set1: {
    children: [],
    itemId: 'set1',
    parent: 'createRecord1',
    props: {
      attribute: 'dateTime',
      value: {
        type: 'expression',
        value: 'sysdate()',
      },
    },
    type: 'ActionSet',
  },
  triggerOnClick: {
    children: ['saveDataStore'],
    itemId: 'triggerOnClick',
    parent: 'saveButton',
    props: {},
    type: 'TriggerOnClick',
  },
  triggerOnClick1: {
    children: ['createRecord'],
    itemId: 'triggerOnClick1',
    parent: 'plusIconButton',
    props: {},
    type: 'TriggerOnClick',
  },
  triggerOnClick2: {
    children: ['resetDataStore'],
    itemId: 'triggerOnClick2',
    parent: 'resetChangesMenuItem',
    props: {},
    type: 'TriggerOnClick',
  },
  triggerOnClick3: {
    children: ['createRecord1'],
    itemId: 'triggerOnClick3',
    parent: 'menuItem',
    props: {},
    type: 'TriggerOnClick',
  },
  triggerOnClick4: {
    children: ['saveDataStore1'],
    itemId: 'triggerOnClick4',
    parent: 'menuItem1',
    props: {},
    type: 'TriggerOnClick',
  },
  triggerOnClick5: {
    children: ['goBack'],
    itemId: 'triggerOnClick5',
    parent: 'backButton',
    props: {},
    type: 'TriggerOnClick',
  },
};
